module.exports = __webpack_public_path__ + "static/media/transporter-training.2b37528e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/scss/icons/teaser/transporter-training.svg
// module id = 907
// module chunks = 0